<template>
  <div
    v-wechat-title="$route.meta.title"
    style="display: flex;flex-direction: column;"
  >
    <common-header @setLocale="getLocale"></common-header>
    <index-banner
      :banner="bannerData"
      :locale="locale"
      v-if="bannerData.length != 0"
    ></index-banner>
    <index-about :locale="locale"></index-about>
    <index-five :locale="locale"></index-five>
    <index-product
      :product="productData"
      :locale="locale"
      v-if="productData.length != 0"
    ></index-product>
    <index-quality :locale="locale"></index-quality>
    <index-contact :locale="locale"></index-contact>
    <common-footer :locale="locale"></common-footer>
  </div>
</template>

<script>
import CommonHeader from "./components/Common/Header";
import IndexBanner from "./components/Index/IndexBanner";
import IndexAbout from "./components/Index/IndexAbout";
import IndexFive from "./components/Index/IndexFive";
import IndexProduct from "./components/Index/IndexProduct";
import indexContact from "./components/Index/IndexContact";
import IndexQuality from "./components/Index/IndexQuality";
import CommonFooter from "./components/Common/Footer";
export default {
  components: {
    CommonHeader,
    IndexBanner,
    IndexAbout,
    IndexFive,
    IndexProduct,
    indexContact,
    IndexQuality,
    CommonFooter
  },
  data() {
    return {
      locale: "zh-cn",
      bannerData: [],
      productData: []
    };
  },
  watch: {
    locale: {
      handler(a, b) {
        console.log("locale变化（indexproduct）", a);
        this.getHome(a);
      },
      immediate: true
    }
  },
  created() {
    // console.clear();
    this.locale = window.localStorage.getItem("lang")
      ? window.localStorage.getItem("lang")
      : "zh-cn";
    this.getHome(this.locale);
  },
  methods: {
    getLocale(e) {
      this.locale = e;
    },
    getTarget() {
      return this.$el;
    },
    getHome(lang) {
      let lang2 = lang ? lang : "zh-cn";
      console.log(lang2);
      this.$axios
        .post(
          "/api/home/index",
          {},
          {
            headers: {
              token: "application",
              "Accept-Language": lang2
            }
          }
        )
        .then(res => {
          console.log("首页数据:", res);
          if (res.data.errorCode === 0) {
            this.bannerData = res.data.data.bannerData;
            this.productData = res.data.data.productCateData;
          } else {
            this.$alert(res.data.errorMsg);
          }
          // console.log(this.bannerData)
          // console.log(this.productData)
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: auto;
  background: #000;
  padding-top: 100px;
  padding-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue